import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';

export interface FileUploadResponse {
    key: string;
    fileSize: number;
    url: string;
}

@Injectable({ providedIn: 'root' })
export class FileUploadApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/files`;
    }

    upload(file: File): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);

        // Return the raw observable - ApiCallService.fetch will unwrap { data, error, status }
        // and pass only the 'data' part to onSuccess callback
        // Backend returns: { data: { key, fileSize, url }, error, status }
        // The backend generates the key (UUID) automatically
        return this.httpClient.post<any>(`${this.url}/upload`, formData);
    }

    getFileUrl(key: string): string {
        return `${this.environmentService.getCurrentApiUrl()}/files/${key}`;
    }
}

